import * as React from 'react';

import * as styles from './styles.css';
import { CONTENT_WRAPPER_ID } from '../../constants/elements';

export function ContentWrapper({ children }: React.PropsWithChildren<{}>) {
  return (
    <div className={styles['container']} id={CONTENT_WRAPPER_ID}>
      {children}
    </div>
  );
}
